export const GOOGLE_AUTH_ID = process.env.REACT_APP_GOOGLE_AUTH_ID;
export const baseURL = process.env.REACT_APP_BASE_URL;
export const SELF_HOST = process.env.REACT_APP_SELF_HOST;
export const GOOGLE_RECAPTCHA_KEY = process.env.REACT_APP_GOOGLE_RECAPTCHA_KEY;
export const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;